import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';

const AdmissionForm = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Replace these with your actual EmailJS credentials
    const serviceID = 'service_tk5zqjo';      // Your EmailJS Service ID
    const templateID = 'template_r81rr53';    // Your EmailJS Template ID
    const publicKey = 'bP79j8Y-gS9V79CJ0';    // Your EmailJS Public Key

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setIsSuccess(true);
        form.current.reset();
        
        // Reset success message after 5 seconds
        setTimeout(() => {
          setIsSuccess(false);
        }, 5000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        alert("❌ Failed to submit form. Please try again or contact us directly.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div style={{ maxWidth: '500px', margin: '0 auto', padding: '20px' }}>
      {isSuccess && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #c3e6cb'
        }}>
          ✅ Application submitted successfully! We'll contact you soon.
        </div>
      )}
      
      <form 
        ref={form} 
        onSubmit={sendEmail}
        style={{
          backgroundColor: '#f8f9fa',
          padding: '30px',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <h2 style={{ color: '#125303', marginBottom: '20px', textAlign: 'center' }}>
          Admission Application Form
        </h2>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
            Full Name *
          </label>
          <input 
            type="text" 
            name="from_name" 
            placeholder="Enter student/parent name" 
            required 
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '1rem'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
            Email Address *
          </label>
          <input 
            type="email" 
            name="email" 
            placeholder="Enter email address" 
            required 
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '1rem'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
            Phone Number *
          </label>
          <input 
            type="tel" 
            name="phone" 
            placeholder="Enter 10-digit mobile number" 
            required 
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '1rem'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
            Class Applying For *
          </label>
          <select 
            name="class" 
            required 
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '1rem',
              backgroundColor: 'white'
            }}
          >
            <option value="">Select Class</option>
            <option value="Pre-KG">Pre-KG</option>
            <option value="LKG">LKG</option>
            <option value="UKG">UKG</option>
            <option value="Class 1">Class 1</option>
            <option value="Class 2">Class 2</option>
            <option value="Class 3">Class 3</option>
            <option value="Class 4">Class 4</option>
            <option value="Class 5">Class 5</option>
            <option value="Class 6">Class 6</option>
            <option value="Class 7">Class 7</option>
            <option value="Class 8">Class 8</option>
            <option value="Class 9">Class 9</option>
            <option value="Class 10">Class 10</option>
            <option value="Class 11">Class 11 (Science)</option>
            <option value="Class 12">Class 12 (Science)</option>
          </select>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
            Additional Information (Optional)
          </label>
          <textarea 
            name="message" 
            placeholder="Any additional information or questions..." 
            rows="4"
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '1rem',
              resize: 'vertical'
            }}
          ></textarea>
        </div>
        
        <button 
          type="submit" 
          disabled={isSubmitting}
          style={{
            width: '100%',
            backgroundColor: isSubmitting ? '#6c757d' : '#125303',
            color: '#fff',
            padding: '14px',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1.1rem',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
            fontWeight: 'bold'
          }}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Application'}
        </button>
        
        <p style={{ 
          fontSize: '12px', 
          color: '#666', 
          marginTop: '15px',
          textAlign: 'center'
        }}>
          We'll contact you within 24 hours
        </p>
      </form>
    </div>
  );
};

export default AdmissionForm;